import VacationsSchedule from 'features/vacationsSchedule';
import { useTitle } from '../helpers';

/**
 * @page VacationsSchedule
 */
const VacationsSchedulePage = () => {
  useTitle('График отпусков');

  return (
    <div>
      <VacationsSchedule />
    </div>
  );
};

export default VacationsSchedulePage;
